import { StepForwardOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const NextNavBtn = ({
  icon,
  displayText = true,
  text = null,
  ...others
}) => {
  return (
    <Button
      type="primary"
      icon={!icon ? <StepForwardOutlined /> : icon}
      {...others}
    >
      {displayText && (text == null ? "Siguiente" : text)}
    </Button>
  );
};
